import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/site-chrome";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Syarat & Ketentuan — jasasebar.com" },
      {
        name: "description",
        content: "Syarat dan ketentuan penggunaan layanan papan promosi jasasebar.com.",
      },
      { property: "og:title", content: "Syarat & Ketentuan — jasasebar.com" },
      {
        property: "og:description",
        content: "Syarat dan ketentuan penggunaan layanan papan promosi jasasebar.com.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://jasasebar.com/terms" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://jasasebar.com/terms" }],
  }),
  component: TermsPage,
});

const sections = [
  {
    title: "1. Penerimaan Ketentuan",
    body: "Dengan mengakses atau menggunakan jasasebar.com, Anda menyetujui syarat dan ketentuan ini. Jika Anda tidak setuju, mohon tidak menggunakan layanan kami.",
  },
  {
    title: "2. Layanan",
    body: "jasasebar.com adalah papan promosi berperingkat untuk jasa dan produk. Pengguna dapat mendaftarkan listing secara gratis dan menaikkan peringkat melalui pembayaran promosi.",
  },
  {
    title: "3. Akun dan Tanggung Jawab",
    body: "Anda bertanggung jawab atas keakuratan informasi listing, keamanan akun Google yang digunakan untuk masuk, serta seluruh aktivitas yang terjadi di akun Anda. Anda wajib berusia minimal 18 tahun atau memiliki izin wali.",
  },
  {
    title: "4. Konten Listing",
    body: "Anda menjamin bahwa konten listing bukan milik pihak lain yang dilanggar haknya, tidak mengandung penipuan, konten ilegal, SARA, pornografi, atau pelanggaran hukum Indonesia lainnya. Kami berhak menyetujui, menolak, atau menghapus listing tanpa pemberitahuan.",
  },
  {
    title: "5. Pembayaran",
    body: "Pembayaran promosi diproses melalui penyedia pembayaran pihak ketiga yang aman. Peringkat diperbarui setelah pembayaran terverifikasi. Dana yang sudah terpakai untuk promosi tidak dapat dikembalikan kecuali terjadi kegagalan sistem di pihak kami.",
  },
  {
    title: "6. Peringkat dan Klik",
    body: "Urutan papan ditentukan oleh total kontribusi promosi. Kami menerapkan validasi anti-duplikasi klik, namun tidak menjamin jumlah klik atau hasil bisnis tertentu dari promosi.",
  },
  {
    title: "7. Pembatasan Tanggung Jawab",
    body: "Layanan disediakan \"sebagaimana adanya\". Kami tidak bertanggung jawab atas kerugian tidak langsung, kehilangan keuntungan, atau gangguan layanan yang berada di luar kendali wajar kami.",
  },
  {
    title: "8. Penghentian",
    body: "Kami dapat menangguhkan atau menghentikan akun yang melanggar ketentuan ini, termasuk penyalahgunaan sistem bid, spam, atau kecurangan klik.",
  },
  {
    title: "9. Perubahan Ketentuan",
    body: "Ketentuan ini dapat diperbarui sewaktu-waktu. Perubahan berlaku sejak dipublikasikan di halaman ini; penggunaan berlanjut dianggap sebagai persetujuan.",
  },
  {
    title: "10. Kontak",
    body: "Pertanyaan mengenai ketentuan ini dapat dikirim melalui halaman kontak atau email dukungan yang tercantum di situs.",
  },
];

function TermsPage() {
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main className="hero-canvas">
        <div className="mx-auto max-w-3xl px-4 py-16">
          <h1 className="font-display text-4xl font-semibold">Syarat &amp; Ketentuan</h1>
          <p className="mt-3 text-muted-foreground">
            Terakhir diperbarui: September 2026. Mohon baca dengan saksama sebelum menggunakan layanan.
          </p>
          <div className="mt-10 space-y-6">
            {sections.map((s) => (
              <section key={s.title} className="surface-card p-6">
                <h2 className="font-display text-lg font-semibold">{s.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.body}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
